module.exports = {"130528001":"宁北街道","130528100":"凤凰镇","130528101":"河渠镇","130528102":"北河庄镇","130528103":"耿庄桥镇","130528104":"东汪镇","130528105":"贾家口镇","130528106":"四芝兰镇","130528107":"大陆村镇","130528108":"苏家庄镇","130528109":"换马店镇","130528110":"唐邱镇","130528200":"侯口乡","130528202":"纪昌庄乡","130528205":"北鱼乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130528.json
// module id = 127
// module chunks = 0